import "./FeedBackForm.scss";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import TextError from "../../../components/textError/TextError";
import PrimaryBtn from "../../../components/primaryBtn/PrimaryBtn";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { baseUrl, feedBackEndPoint } from "../../../utils/apiData";
import { Fragment, useState } from "react";

const FeedBackForm = () => {
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const storeFeed = async (data, resetForm) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${feedBackEndPoint}`, {
        ...data,
      });
      if (res?.data?.success) {
        goTop();
        setSuccess(true);
        resetForm();
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  const initialValues = {
    name: "",
    designation: "",
    email: "",
    companyName: "",
    overallExperience: null,
    specificResults: "",
    standoutService: "",
    improvementSuggestion: "",
    testimonial: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Field is required!"),
    designation: Yup.string().required("Field is required!"),
    email: Yup.string()
      .email("Invalid email format!")
      .required("Email is required!"),
    overallExperience: Yup.string().required("Field is required!"),
    companyName: Yup.string().required("Field is required!"),
    standoutService: Yup.string().required("Field is required!"),
    improvementSuggestion: Yup.string().required("Field is required!"),
    testimonial: Yup.string().required("Field is required!"),
  });

  const onSubmit = (values, { resetForm }) => {
    storeFeed(values, resetForm);
  };

  return (
    <section className="feed_form pt-5 p_b">
      <div className="content_wrap pt-5">
        {success ? (
          <div className="success_screen mt-5">
            <h3>Thank You</h3>
            <p>Thank you for your feedback. We appreciate your input!</p>
          </div>
        ) : (
          <div className="form_wraps">
            <h3 className="text-center mb">Feedback Form</h3>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="bi_field">
                    <div className="field_wrap">
                      <label htmlFor="Name">
                        Name <sup>*</sup>
                      </label>
                      <Field
                        type="text"
                        placeholder="Enter Name"
                        id="Name"
                        name="name"
                        autoComplete="off"
                      />
                      <ErrorMessage name="name" component={TextError} />
                    </div>
                    <div className="field_wrap">
                      <label htmlFor="Designation">
                        Designation <sup>*</sup>
                      </label>
                      <Field
                        type="text"
                        placeholder="Enter Designation"
                        id="Designation"
                        name="designation"
                        autoComplete="off"
                      />
                      <ErrorMessage name="designation" component={TextError} />
                    </div>
                  </div>

                  <div className="bi_field">
                    <div className="field_wrap">
                      <label htmlFor="Email">
                        Email <sup>*</sup>
                      </label>
                      <Field
                        type="email"
                        placeholder="Enter Email"
                        id="Email"
                        name="email"
                        autoComplete="off"
                      />
                      <ErrorMessage name="email" component={TextError} />
                    </div>

                    <div className="field_wrap">
                      <label htmlFor="CompanyName">
                        Company Name <sup>*</sup>
                      </label>
                      <Field
                        type="text"
                        placeholder="Enter Company Name"
                        id="CompanyName"
                        name="companyName"
                        autoComplete="off"
                      />
                      <ErrorMessage name="companyName" component={TextError} />
                    </div>
                  </div>
                  {/* Rating */}
                  <div className="field_wrap">
                    <label htmlFor="overallExperience">
                      How was your overall experience working with our team?
                      <sup>*</sup>
                    </label>
                    <div
                      style={{ display: "flex", gap: "5px", fontSize: "30px" }}
                    >
                      {[1, 2, 3, 4, 5].map((star) => (
                        <FaStar
                          key={star}
                          onClick={() =>
                            setFieldValue("overallExperience", star)
                          }
                          className={
                            values.overallExperience >= star
                              ? "active"
                              : "normal"
                          }
                          style={{ cursor: "pointer" }}
                        />
                      ))}
                    </div>
                    <ErrorMessage
                      name="overallExperience"
                      component={TextError}
                    />
                  </div>

                  <div className="field_wrap">
                    <label htmlFor="SpecificResults">
                      What specific results or benefits did you see after
                      working with us?
                    </label>
                    <Field
                      type="text"
                      placeholder="Enter"
                      id="SpecificResults"
                      name="specificResults"
                      autoComplete="off"
                    />
                  </div>

                  <div className="field_wrap">
                    <label htmlFor="StandoutService">
                      Was there anything that stood out about our service or
                      approach? <sup>*</sup>
                    </label>
                    <Field
                      type="text"
                      placeholder="Enter"
                      id="StandoutService"
                      name="standoutService"
                      autoComplete="off"
                    />
                    <ErrorMessage
                      name="standoutService"
                      component={TextError}
                    />
                  </div>

                  <div className="field_wrap">
                    <label htmlFor="ImprovementSuggestion">
                      What’s one thing we could do to improve your experience
                      with Supagrow? <sup>*</sup>
                    </label>
                    <Field
                      type="text"
                      placeholder="Enter"
                      id="ImprovementSuggestion"
                      name="improvementSuggestion"
                      autoComplete="off"
                    />
                    <ErrorMessage
                      name="improvementSuggestion"
                      component={TextError}
                    />
                  </div>

                  <div className="field_wrap">
                    <label htmlFor="overallExperience">
                      Short Testimonial <sup>*</sup>
                    </label>
                    <Field
                      as="textarea"
                      type="text"
                      placeholder="Testimonial"
                      id="testimonial"
                      name="testimonial"
                      autoComplete="off"
                    />
                    <ErrorMessage
                      name="testimonial"
                      type="submit"
                      component={TextError}
                    />
                  </div>
                  <div className="btn_line">
                    <PrimaryBtn
                      title={loader ? "Loading..." : "Submit"}
                      type={loader ? "button" : "submit"}
                      varient="dark"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeedBackForm;
